import type { ReactNode } from "react";
import {
  IconUserPlus,
  IconIdBadge,
  IconAlertTriangle,
  IconHeadset,
  IconBell,
} from "@tabler/icons-react";
import type { NotificationType } from "../types";

export function notificationIcon(type: NotificationType, size = 14): ReactNode {
  switch (type) {
    case "BrokerJoined":
      return <IconUserPlus size={size} />;
    case "LicenseActivated":
      return <IconIdBadge size={size} />;
    case "SeatsLow":
      return <IconAlertTriangle size={size} />;
    case "SupportReplied":
      return <IconHeadset size={size} />;
    default:
      return <IconBell size={size} />;
  }
}

export const notificationIconTint: Record<NotificationType, string> = {
  BrokerJoined: "bg-success-soft text-success",
  LicenseActivated: "bg-brand-50 text-brand-600",
  SeatsLow: "bg-warning-soft text-warning",
  SupportReplied: "bg-info-soft text-info",
};
